<div class="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-xl">
  <div>
    <h1 class="font-headline-lg text-headline-lg text-text-main dark:text-on-surface mb-1">Technicians</h1>
  </div>
  @if (authService.isAdmin()) {
  <div class="flex items-center gap-3">
    <button (click)="openAddModal()" class="h-[48px] px-6 bg-[#00B9F2] text-white rounded-lg hover:opacity-90 transition-opacity flex items-center gap-2 font-label-md">
      <span class="material-symbols-outlined">person_add</span>
      Add Technician
    </button>
  </div>
  }
</div>

<div class="md:hidden flex flex-col gap-3">
  @if (loading()) {
    <p class="text-center text-text-muted dark:text-on-surface-variant font-body-sm py-6">Loading technicians...</p>
  } @else if (error()) {
    <p class="text-center text-error font-body-sm py-6">{{ error() }}</p>
  } @else if (technicians().length === 0) {
    <p class="text-center text-text-muted dark:text-on-surface-variant font-body-sm py-6">No technicians found.</p>
  }
  @for (technician of technicians(); track technician.technicianId) {
    <div class="bg-background dark:bg-surface-container-low border border-border-subtle dark:border-outline-variant rounded-xl p-4 flex flex-col gap-3 shadow-sm">
      <div class="flex items-center justify-between gap-3">
        <div class="flex items-center gap-3 min-w-0">
          <div class="w-10 h-10 rounded-lg bg-blue-50 dark:bg-surface-container-highest border border-border-subtle dark:border-outline-variant flex items-center justify-center text-[#00B9F2] overflow-hidden shrink-0">
            @if (technician.photoUrl) {
              <img [src]="technician.photoUrl" [alt]="technician.firstName" class="w-full h-full object-cover" />
            } @else {
              <span class="material-symbols-outlined">engineering</span>
            }
          </div>
          <p class="font-label-md text-text-main dark:text-on-surface truncate">{{ technician.firstName }} {{ technician.lastName }}</p>
        </div>
        <span class="shrink-0 inline-flex items-center px-2 py-1 rounded-full font-label-sm border"
              [style.background-color]="(technician.isActive ? '#8DC63F' : '#64748B') + '1A'"
              [style.color]="technician.isActive ? '#8DC63F' : '#64748B'"
              [style.border-color]="(technician.isActive ? '#8DC63F' : '#64748B') + '33'">
          <span class="w-1.5 h-1.5 rounded-full mr-1.5" [style.background-color]="technician.isActive ? '#8DC63F' : '#64748B'"></span>
          {{ technician.isActive ? 'Active' : 'Inactive' }}
        </span>
      </div>
      <div class="text-xs text-text-muted dark:text-on-surface-variant flex flex-col gap-0.5">
        <p>{{ technician.email || 'N/A' }}</p>
        <p>{{ technician.phNo || 'N/A' }}</p>
      </div>
      @if (authService.isAdmin()) {
        <div class="flex items-center gap-2 pt-2 border-t border-border-subtle dark:border-outline-variant">
          <button (click)="openEditModal(technician)"
                  class="flex-1 h-9 rounded-lg border border-border-subtle dark:border-outline-variant text-text-main dark:text-on-surface hover:bg-surface-variant dark:hover:bg-surface-variant transition-colors font-label-sm flex items-center justify-center gap-1.5">
            <span class="material-symbols-outlined text-[18px]">edit</span>
            Edit
          </button>
          <button (click)="deactivateTechnician(technician)" [disabled]="!technician.isActive"
                  class="flex-1 h-9 rounded-lg border border-border-subtle dark:border-outline-variant text-text-main dark:text-on-surface hover:bg-surface-variant dark:hover:bg-surface-variant transition-colors font-label-sm flex items-center justify-center gap-1.5 disabled:opacity-30">
            <span class="material-symbols-outlined text-[18px]">block</span>
            Deactivate
          </button>
        </div>
      }
    </div>
  }
</div>

<div class="hidden md:flex bg-background dark:bg-surface-container-low border border-border-subtle dark:border-outline-variant rounded-xl flex-col overflow-hidden shadow-sm">
  <div class="overflow-x-auto">
    <table class="w-full text-left border-collapse min-w-[700px]">
      <thead>
        <tr class="bg-surface dark:bg-surface-container border-b border-border-subtle dark:border-outline-variant">
          <th class="p-4 font-label-md text-text-muted dark:text-on-surface-variant font-medium">Name</th>
          <th class="p-4 font-label-md text-text-muted dark:text-on-surface-variant font-medium">Email</th>
          <th class="p-4 font-label-md text-text-muted dark:text-on-surface-variant font-medium">Phone</th>
          <th class="p-4 font-label-md text-text-muted dark:text-on-surface-variant font-medium">Status</th>
          <th class="p-4 font-label-md text-text-muted dark:text-on-surface-variant font-medium text-right">Actions</th>
        </tr>
      </thead>
      <tbody class="divide-y divide-border-subtle dark:divide-outline-variant">
        @if (loading()) {
          <tr>
            <td colspan="5" class="p-6 text-center text-text-muted dark:text-on-surface-variant font-body-sm">Loading technicians...</td>
          </tr>
        } @else if (error()) {
          <tr>
            <td colspan="5" class="p-6 text-center text-error font-body-sm">{{ error() }}</td>
          </tr>
        } @else if (technicians().length === 0) {
          <tr>
            <td colspan="5" class="p-6 text-center text-text-muted dark:text-on-surface-variant font-body-sm">No technicians found.</td>
          </tr>
        }
        @for (technician of technicians(); track technician.technicianId) {
          <tr class="hover:bg-surface dark:hover:bg-surface-variant/50 transition-colors group">
            <td class="p-4">
              <div class="flex items-center gap-3">
                <div class="w-10 h-10 rounded-lg bg-blue-50 dark:bg-surface-container-highest border border-border-subtle dark:border-outline-variant flex items-center justify-center text-[#00B9F2] overflow-hidden shrink-0">
                  @if (technician.photoUrl) {
                    <img [src]="technician.photoUrl" [alt]="technician.firstName" class="w-full h-full object-cover" />
                  } @else {
                    <span class="material-symbols-outlined">engineering</span>
                  }
                </div>
                <p class="font-label-md text-text-main dark:text-on-surface">{{ technician.firstName }} {{ technician.lastName }}</p>
              </div>
            </td>
            <td class="p-4">
              <p class="font-body-sm text-text-main dark:text-on-surface">{{ technician.email || 'N/A' }}</p>
            </td>
            <td class="p-4">
              <p class="font-body-sm text-text-main dark:text-on-surface">{{ technician.phNo || 'N/A' }}</p>
            </td>
            <td class="p-4">
              <span class="inline-flex items-center px-2 py-1 rounded-full font-label-sm border"
                    [style.background-color]="(technician.isActive ? '#8DC63F' : '#64748B') + '1A'"
                    [style.color]="technician.isActive ? '#8DC63F' : '#64748B'"
                    [style.border-color]="(technician.isActive ? '#8DC63F' : '#64748B') + '33'">
                <span class="w-1.5 h-1.5 rounded-full mr-1.5" [style.background-color]="technician.isActive ? '#8DC63F' : '#64748B'"></span>
                {{ technician.isActive ? 'Active' : 'Inactive' }}
              </span>
            </td>
            <td class="p-4 text-right">
              @if (authService.isAdmin()) {
                <div class="flex items-center justify-end gap-2 opacity-0 group-hover:opacity-100 transition-opacity">
                  <button (click)="openEditModal(technician)"
                          class="p-2 text-text-muted dark:text-on-surface-variant hover:text-[#00B9F2] rounded hover:bg-surface-variant dark:hover:bg-surface-container-highest transition-colors"
                          title="Edit">
                    <span class="material-symbols-outlined text-[20px]">edit</span>
                  </button>
                  <button (click)="deactivateTechnician(technician)" [disabled]="!technician.isActive"
                          class="p-2 text-text-muted dark:text-on-surface-variant hover:text-[#ef4444] rounded hover:bg-surface-variant dark:hover:bg-surface-container-highest transition-colors disabled:opacity-30"
                          title="Deactivate">
                    <span class="material-symbols-outlined text-[20px]">block</span>
                  </button>
                </div>
              }
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>
</div>

@if (modalOpen()) {
  <div class="fixed inset-0 bg-black/40 z-[60] flex items-center justify-center p-4" (click)="closeModal()">
    <div class="bg-background dark:bg-surface-container-low rounded-xl shadow-lg w-full max-w-md max-h-[90vh] overflow-y-auto" (click)="$event.stopPropagation()">
      <div class="p-lg border-b border-border-subtle dark:border-outline-variant flex items-center justify-between">
        <h2 class="font-headline-sm text-headline-sm text-text-main dark:text-on-surface">
          {{ editingTechnician() === null ? 'Add Technician' : 'Edit Technician' }}
        </h2>
        <button (click)="closeModal()" class="p-1 rounded-full hover:bg-surface-variant dark:hover:bg-surface-variant text-text-muted dark:text-on-surface-variant">
          <span class="material-symbols-outlined">close</span>
        </button>
      </div>

      <form [formGroup]="technicianForm" (ngSubmit)="saveTechnician()">
        <div class="p-lg grid grid-cols-1 gap-4">
          <label class="flex flex-col gap-1">
            <span class="font-label-sm text-text-muted dark:text-on-surface-variant">Photo</span>
            <div class="flex items-center gap-3">
              <div class="w-16 h-16 rounded-full bg-blue-50 dark:bg-surface-container-highest border border-border-subtle dark:border-outline-variant flex items-center justify-center text-[#00B9F2] overflow-hidden shrink-0">
                @if (photoPreviewUrl()) {
                  <img [src]="photoPreviewUrl()" alt="Technician photo" class="w-full h-full object-cover" />
                } @else {
                  <span class="material-symbols-outlined text-[28px]">engineering</span>
                }
              </div>
              <div class="flex flex-col gap-1">
                <input type="file" accept="image/*" (change)="onPhotoSelected($event)" class="text-body-sm text-text-main dark:text-on-surface">
                @if (photoPreviewUrl()) {
                  <button type="button" (click)="removePhoto()" class="text-xs text-text-muted dark:text-on-surface-variant hover:text-[#ef4444] text-left w-fit">Remove photo</button>
                }
              </div>
            </div>
          </label>

          <label class="flex flex-col gap-1">
            <span class="font-label-sm text-text-muted dark:text-on-surface-variant">First Name *</span>
            <input formControlName="firstName" type="text"
                   class="bg-surface dark:bg-surface-container-highest border border-border-subtle dark:border-outline-variant rounded-lg px-3 py-2 text-body-sm text-text-main dark:text-white focus:outline-none focus:border-[#00B9F2] focus:ring-1 focus:ring-[#00B9F2]">
            @if (technicianForm.controls.firstName.invalid && technicianForm.controls.firstName.touched) {
              <span class="text-xs text-error">First name is required.</span>
            }
          </label>

          <label class="flex flex-col gap-1">
            <span class="font-label-sm text-text-muted dark:text-on-surface-variant">Last Name</span>
            <input formControlName="lastName" type="text"
                   class="bg-surface dark:bg-surface-container-highest border border-border-subtle dark:border-outline-variant rounded-lg px-3 py-2 text-body-sm text-text-main dark:text-white focus:outline-none focus:border-[#00B9F2] focus:ring-1 focus:ring-[#00B9F2]">
          </label>

          <label class="flex flex-col gap-1">
            <span class="font-label-sm text-text-muted dark:text-on-surface-variant">Email</span>
            <input formControlName="email" type="email"
                   class="bg-surface dark:bg-surface-container-highest border border-border-subtle dark:border-outline-variant rounded-lg px-3 py-2 text-body-sm text-text-main dark:text-white focus:outline-none focus:border-[#00B9F2] focus:ring-1 focus:ring-[#00B9F2]">
          </label>

          <label class="flex flex-col gap-1">
            <span class="font-label-sm text-text-muted dark:text-on-surface-variant">Phone Number</span>
            <input formControlName="phNo" type="text"
                   class="bg-surface dark:bg-surface-container-highest border border-border-subtle dark:border-outline-variant rounded-lg px-3 py-2 text-body-sm text-text-main dark:text-white focus:outline-none focus:border-[#00B9F2] focus:ring-1 focus:ring-[#00B9F2]">
          </label>
        </div>

        <div class="p-lg border-t border-border-subtle dark:border-outline-variant flex items-center justify-end gap-3">
          <button type="button" (click)="closeModal()"
                  class="h-[44px] px-6 border border-border-subtle dark:border-outline-variant rounded-lg text-text-main dark:text-on-surface hover:bg-surface-variant dark:hover:bg-surface-variant transition-colors font-label-md">
            Cancel
          </button>
          <button type="submit" [disabled]="saving()"
                  class="h-[44px] px-6 bg-[#00B9F2] text-white rounded-lg hover:opacity-90 transition-opacity font-label-md disabled:opacity-50">
            {{ saving() ? 'Saving...' : (editingTechnician() === null ? 'Add Technician' : 'Save Changes') }}
          </button>
        </div>
      </form>
    </div>
  </div>
}
